import { z } from 'zod';
import { GenericLegalTransactionRelationshipSchema } from '../../GenericLegalTransactionRelationshipSchema';
import { initLegalTransactionRelationshipSkeleton } from '../../ILegalTransactionRelationship';
import { LegalTransactionRelationshipTypeEnum } from '../../LegalTransactionRelationshipTypeEnum';
import {
  IMemberParticipant,
  ParticipantMemberSchema,
} from '../../Members/IMemberParticipant';
import { ReasonLandRegisterQuerySchema } from './IReasonLandRegisterQuery';

export const LandRegisterQueryRelationshipSchema =
  GenericLegalTransactionRelationshipSchema(
    z.literal(LegalTransactionRelationshipTypeEnum.LandRegisterQuery),
    z.literal(2).optional(),
    z.object({
      ReasonLandRegisterQueryArray: z.array(ReasonLandRegisterQuerySchema),
    }),
    ParticipantMemberSchema
  );

export type ILandRegisterQueryRelationship = Omit<
  z.infer<typeof LandRegisterQueryRelationshipSchema>,
  'Members'
> & {
  Members: IMemberParticipant[];
};

export function getEmptyLandRegisterQueryRelationship(): ILandRegisterQueryRelationship {
  return {
    ...initLegalTransactionRelationshipSkeleton(),
    Version: 2,
    idRelationshipType: LegalTransactionRelationshipTypeEnum.LandRegisterQuery,
    data: {
      ReasonLandRegisterQueryArray: [],
    },
    Members: [],
  };
}
